import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FaHome, FaUser, FaCalendarCheck } from "react-icons/fa";
import { FaIndianRupeeSign } from "react-icons/fa6";

const quickLinks = [
  { title: "", icon: <FaHome />, url: "/dashboard" },
  { title: "", icon: <FaCalendarCheck />, url: "/attendance" },
  { title: "", icon: <FaIndianRupeeSign />, url: "/payments" },
  { title: "", icon: <FaUser />, url: "/profile" },
];

export default function BottomNav() {
  const location = useLocation();

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="fixed bottom-0 left-0 w-full bg-pragyaBlue/10 backdrop-blur-md shadow-[0_-4px_20px_-5px_rgba(0,0,0,0.1)] border-t border-white/20 flex justify-around p-4 z-50"
    >
      {quickLinks.map((link, index) => {
        const isActive = location.pathname === link.url;

        return (
          <Link
            to={link.url}
            key={index}
            aria-label={link.title}
            title={link.title}
            className={`flex flex-col items-center transition-all duration-300 relative ${isActive ? "text-pragyaBlue" : "text-slate-400 hover:text-slate-600"
              }`}
          >
            {isActive && (
              <motion.div
                layoutId="nav-indicator"
                className="absolute -top-4 w-8 h-1 bg-pragyaBlue rounded-b-full"
                transition={{ type: "spring", stiffness: 500, damping: 30 }}
              />
            )}

            <motion.div
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              className={`text-2xl mb-1 ${isActive ? "drop-shadow-sm" : ""}`}
            >
              {link.icon}
            </motion.div>
            <p className={`text-[10px] font-medium tracking-wide ${isActive ? "opacity-100" : "opacity-0 scale-0"} transition-all duration-300 absolute -bottom-2`}>
              {link.title}
            </p>
          </Link>
        );
      })}
    </motion.div>
  );
}
